   import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const TataCapitalBikeEmiCalculator     = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the Tata Capital Bike Loan EMI Calculator?",
            "answer": "It’s an online tool that helps you determine your monthly EMI payments based on loan amount, interest rate, and tenure."
          },
          {
            "question": "Is the calculator free to use?",
            "answer": "Yes, TheFinMaster’s Tata Capital Bike Loan EMI Calculator is completely free and accessible."
          },
          {
            "question": "What details are required to use the EMI calculator?",
            "answer": "You’ll need to input the loan amount, interest rate, and loan tenure."
          },
          {
            "question": "Does the calculator include processing fees?",
            "answer": "No, it only shows EMI based on loan and interest. Processing fees should be considered separately."
          },
          {
            "question": "Can I compare different tenures?",
            "answer": "Yes, the calculator allows you to adjust tenures and see how it affects your EMI."
          },
          {
            "question": "What is the benefit of prepayment in a Tata Capital bike loan?",
            "answer": "Prepayment reduces the principal balance, thereby lowering total interest burden."
          },
          {
            "question": "Does the EMI change with time?",
            "answer": "No, EMIs remain constant in fixed-rate loans. But principal and interest share varies monthly."
          },
          {
            "question": "Can I calculate EMI for used bike loans too?",
            "answer": "Yes, the calculator can be used for both new and used bike loans from Tata Capital."
          },
          {
            "question": "What if interest rates change after taking the loan?",
            "answer": "If your loan is on a floating rate, EMI may change based on revised interest rates."
          },
          {
            "question": "How accurate is the EMI calculator?",
            "answer": "It offers near-accurate estimations but final values may vary slightly based on processing fees or insurance."
          },
          {
            "question": "Will the calculator show me the total repayment amount?",
            "answer": "Yes, you can also view the total interest payable and overall cost of the loan."
          },
          {
            "question": "Is the calculator useful for co-applicant loans?",
            "answer": "Yes, it can still be used to calculate EMIs for jointly held bike loans."
          },
          {
            "question": "Can I download the amortisation schedule?",
            "answer": "While theFinMaster does not currently support downloads, you can copy or screenshot the schedule."
          },
          {
            "question": "What happens if I miss an EMI?",
            "answer": "Missing EMIs could lead to penalties and impact your credit score."
          },
          {
            "question": "Can I use this calculator offline?",
            "answer": "TheFinMaster’s EMI Calculator is an online tool and requires an internet connection for accurate results."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Tata Capital Bike Loan EMI Calculator – Easy Loan Planning Tool</title>
        <meta  name='description' content='Use the Tata Capital EMI Calculator to calculate your bike loan payments. Plan EMIs and interest outflows with confidence.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/tata-capital-bank-bike-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Tata Capital Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
            <h1 className="text-2xl font-bold mb-4">Tata Capital Bike Loan EMI Calculator</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Tata Capital Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Looking to buy your dream bike with a Tata Capital two-wheeler loan? Get a clear picture of your monthly financial obligations using TheFinMaster’s comprehensive Tata Capital Bike Loan EMI Calculator. This advanced tool enables you to forecast your EMIs, plan better, and take control of your finances. Whether you're eyeing a premium motorcycle or a daily commuter, knowing your EMI in advance allows you to manage your budget without surprises.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Bike Loan EMI (Equated Monthly Installment) is a fixed monthly amount paid by the borrower to the lender to repay the loan taken for purchasing a two-wheeler. Each EMI consists of both principal and interest components. In the early stages of the repayment period, the interest component is higher, while in later stages, the principal component dominates. This structure ensures a systematic repayment of your loan over a predetermined tenure, easing the financial burden with predictable monthly outgoings.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For instance, if you borrow ₹1,00,000 at an interest rate of 11% per annum for a period of 24 months, your monthly EMI would be a combination of the principal repayment and the interest accrued, split evenly across the loan tenure.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Tata Capital Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Tata Capital Bike Loan EMI Calculator is an intuitive digital tool designed to help you estimate the monthly installment you will need to pay when opting for a bike loan from Tata Capital. It takes into account the loan amount, interest rate, and loan tenure to give you an accurate EMI figure instantly. Whether you are planning for a low-budget scooter or a high-end superbike, this calculator helps you analyze your affordability in seconds.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using this tool ensures transparency and clarity in your loan planning process, eliminating guesswork and helping you understand the exact financial commitment you're stepping into.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Tata Capital Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Instant Results:</strong> Get immediate EMI results without manual calculations.</li>
                <li><strong>Accurate Projections:</strong> Know the exact EMI based on live financial inputs.</li>
                <li><strong>Budget Planning:</strong> Helps you choose a loan term that aligns with your budget.</li>
                <li><strong>Compare Scenarios:</strong> Adjust variables like loan amount and tenure to explore different financial scenarios.</li>
                <li><strong>User-Friendly Interface:</strong> Easy to use for all types of borrowers, whether experienced or first-time loan seekers.</li>
                <li><strong>Saves Time:</strong> Avoid lengthy consultations and paperwork just to get an EMI quote.</li>
                <li><strong>No Hidden Charges:</strong> Offers a transparent breakdown of your financial obligation.</li>
              </ul>
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s EMI Calculator simplifies your loan planning process and empowers you to make informed financial decisions tailored to your lifestyle.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Tata Capital Bike Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This tool works on a basic financial formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan Amount</li>
              <li>R = Monthly Interest Rate</li>
              <li>N = Loan Tenure in Months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Suppose you want to take a bike loan of ₹1,50,000 from Tata Capital at an interest rate of 10.5% per annum for 36 months.<br />
              Monthly Interest Rate (R) = 10.5 / 12 / 100 = 0.00875<br />
              Loan Tenure (N) = 36 months<br />
              Using the formula: EMI = ₹1,500,000 x 0.00875 x (1+0.00875)^36 / ((1+0.00875)^36 – 1) EMI ≈ ₹4,877<br />
              This EMI includes both the interest and the principal, allowing you to budget your monthly finances precisely.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a complete breakdown of your bike loan repayment plan over the entire tenure. It outlines the EMI breakup month-wise, showing how much goes towards interest and how much towards the principal every month. In early months, a larger portion of EMI goes toward interest, gradually shifting to principal repayment in later months. This table provides full transparency and helps you see the repayment journey clearly.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Example Loan ₹1,20,000, Interest Rate 11%, Tenure 12 Months):</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,584</td>
                    <td className="border px-4 py-2">1,030</td>
                    <td className="border px-4 py-2">1,10,416</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,666</td>
                    <td className="border px-4 py-2">948</td>
                    <td className="border px-4 py-2">1,00,750</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,748</td>
                    <td className="border px-4 py-2">866</td>
                    <td className="border px-4 py-2">91,002</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,831</td>
                    <td className="border px-4 py-2">783</td>
                    <td className="border px-4 py-2">81,171</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,915</td>
                    <td className="border px-4 py-2">699</td>
                    <td className="border px-4 py-2">71,256</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,000</td>
                    <td className="border px-4 py-2">614</td>
                    <td className="border px-4 py-2">61,256</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,084</td>
                    <td className="border px-4 py-2">530</td>
                    <td className="border px-4 py-2">51,172</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,170</td>
                    <td className="border px-4 py-2">444</td>
                    <td className="border px-4 py-2">41,002</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,255</td>
                    <td className="border px-4 py-2">359</td>
                    <td className="border px-4 py-2">30,747</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,342</td>
                    <td className="border px-4 py-2">272</td>
                    <td className="border px-4 py-2">20,405</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">10,429</td>
                    <td className="border px-4 py-2">185</td>
                    <td className="border px-4 py-2">9,976</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">10,614</td>
                    <td className="border px-4 py-2">9,976</td>
                    <td className="border px-4 py-2">108</td>
                    <td className="border px-4 py-2">0</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Balance  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "10,614", "9,584", "1,030", "1,10,416"],
          ["2", "10,614", "9,666", "948", "1,00,750"],
          ["3", "10,614", "9,748", "866", "91,002"],
          ["4", "10,614", "9,831", "783", "81,171"],
          ["5", "10,614", "9,915", "699", "71,256"],
          ["6", "10,614", "10,000", "614", "61,256"],
          ["7", "10,614", "10,084", "530", "51,172"],
          ["8", "10,614", "10,170", "444", "41,002"],
          ["9", "10,614", "10,255", "359", "30,747"],
          ["10", "10,614", "10,342", "272", "20,405"],
          ["11", "10,614", "10,429", "185", "9,976"],
          ["12", "10,614", "9,976", "108", "0"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "10,614", "9,584", "1,030", "1,10,416"],
           ["2", "10,614", "9,666", "948", "1,00,750"],
           ["3", "10,614", "9,748", "866", "91,002"],
           ["4", "10,614", "9,831", "783", "81,171"],
           ["5", "10,614", "9,915", "699", "71,256"],
           ["6", "10,614", "10,000", "614", "61,256"],
           ["7", "10,614", "10,084", "530", "51,172"],
           ["8", "10,614", "10,170", "444", "41,002"],
           ["9", "10,614", "10,255", "359", "30,747"],
           ["10", "10,614", "10,342", "272", "20,405"],
           ["11", "10,614", "10,429", "185", "9,976"],
           ["12", "10,614", "9,976", "108", "0"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Balance(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> A higher loan results in higher EMIs, though you may benefit from lower interest rates for larger amounts.</li>
                <li><strong>Interest Rate:</strong> Even a small increase in interest rate can lead to significantly higher EMIs.</li>
                <li><strong>Tenure:</strong> Longer loan durations reduce monthly EMI amounts but increase total interest outgo.</li>
                <li><strong>Processing Fees:</strong> These are one-time fees but add to your upfront cost and indirectly impact affordability.</li>
                <li><strong>Prepayments:</strong> Making partial payments during the tenure or closing the loan early can reduce interest burden.</li>
                <li><strong>Credit Score:</strong> A higher CIBIL score often qualifies you for lower interest rates.</li>
                <li><strong>Income Stability:</strong> Lenders may offer flexible EMIs and longer tenures based on your income and employment status.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                           {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default TataCapitalBikeEmiCalculator   ;
